import React from 'react';
import styles from './AssignmentList.module.scss';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import Assignment from '../Assignment/Assignment';
import { LoadingSpinner } from '../Icon/icons';
import Icon from '../Icon/Icon';
import { CustomButton } from '../Button/Button';

const AssignmentList = ({ assignments, isAssignmentsLoading, handleAssignmentClick, setIsShowRecordingRequests }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mainWrapper}>
      <CustomButton className={styles.backButton} onClick={() => setIsShowRecordingRequests(false)} variant="link">
        <Icon src="back" className={styles.backIcon} />
        <span>{t('general.back')}</span>
      </CustomButton>

      <div className={styles.sectionWrapper}>
        <div className={styles.mainText}>{t('home_page.recording_request')}</div>
        {isAssignmentsLoading ? (
          <div className={styles.spinnerContainer}>
            <LoadingSpinner theme="light" />
          </div>
        ) : (
          <div className={styles.assignmentsContainer}>
            {assignments.map(assignment => (
              <Assignment key={assignment.storyId} assignment={assignment} handleAssignmentClick={handleAssignmentClick} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignmentList;
